interface HtmlViewerProps {
  html: string;
}

const HtmlViewer: React.FC<HtmlViewerProps> = ({ html }) => {
  return (
    <div
      className="prose prose-sm max-w-none text-gray-800
                 [&_ul]:list-disc [&_ul]:pl-5
                 [&_ol]:list-decimal [&_ol]:pl-5
                 [&_li]:mb-1"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default HtmlViewer;
